import React, { ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import LoadingBackdrop from '../../../atoms/loader/LoadingBackdrop';
import {
  DashlineSeparator,
  HeadlineContainer,
  buttonStyle,
  bottomLinkStyle,
} from '../../../components/common/CommonStyle';
import { RootState } from '../../../store';
import OTPInput from '../../../components/otp/OTPInput';
import Button from '../../../atoms/buttons/Button';
import JoinSkipButton from '../../../components/join/JoinSkipButton';
import EmailCaption from './EmailCaption';
import { OtpNextButtonWrapper, usePassOtpLink } from './ChangeEmailStyle';
import { changeEmailVerifyOtpAction, setChangeEmailVerifyData } from '../../../actions/authActions';

const ChangeEmailOTP = (props: any): ReactElement => {
  const {
    email,
    isFetching,
    showUsePassword,
    setChangeEmailStep,
    setNewEmail,
    redirectStep,
    setNewEmailCaptcha,
    showEdit = true,
  } = props;
  const [otpValue, setOTPValue] = React.useState<string>('');
  const { changeEmailVerifyData } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  const isOTPError = changeEmailVerifyData?.status === 'error';

  const handleBotButtonClick = () => {
    setNewEmail('');
    setChangeEmailStep('change_email_button');
    dispatch(setChangeEmailVerifyData({ redirectTo: 'none' }));
  };

  const handleSubmit = otp => {
    const successRedirect = redirectStep === 'change_new_email_otp' ? 'success' : 'change_new_email';

    dispatch(
      changeEmailVerifyOtpAction(
        changeEmailVerifyData?.otpToken,
        email,
        otp,
        'change_email',
        redirectStep,
        successRedirect
      )
    );
  };

  const handleUsePasswordClick = () => {
    setChangeEmailStep('change_email_password');
  };

  const handleBackToEmail = () => {
    setChangeEmailStep('change_new_email');
    setNewEmailCaptcha('');
  };

  return (
    <>
      <LoadingBackdrop active={isFetching} customStyle={{ height: '100%' }} />
      <HeadlineContainer>
        <EmailCaption
          label={isOTPError ? `The passcode didn’t match. Try again.` : `We’ve sent a one time passcode to:`}
          email={email}
          showEdit={showEdit}
          handleEditClick={handleBackToEmail}
        />
      </HeadlineContainer>
      <DashlineSeparator />
      <OTPInput
        emailVerifyData={changeEmailVerifyData}
        otpStatus={changeEmailVerifyData?.status || ''}
        resendOTPTitle={'Didn’t get a code?'}
        otpValue={otpValue}
        setOTPValue={setOTPValue}
        handleOTPAutoSubmit={(otp: string) => handleSubmit(otp)}
        type={'privateChangeEmail'}
        handleBotButtonClick={handleBotButtonClick}
        redirectStep={redirectStep}
      />
      <DashlineSeparator />
      <OtpNextButtonWrapper>
        <Button
          customStyle={buttonStyle}
          buttonType="primaryRed"
          type="button"
          name="commit"
          onClick={() => handleSubmit(otpValue)}
          disabled={isEmpty(otpValue) || changeEmailVerifyData?.is_last_attempt || otpValue.length < 6}
        >
          Next
        </Button>
        {showUsePassword ? (
          <JoinSkipButton
            data-test-id="use-password-link"
            label="Use Password Instead"
            customStyle={{ ...bottomLinkStyle, fontSize: 16 }}
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            customWrapperStyle={usePassOtpLink}
            onClick={handleUsePasswordClick}
          />
        ) : (
          <JoinSkipButton
            label="Cancel"
            customWrapperStyle={{ textAlign: 'center' }}
            customStyle={bottomLinkStyle}
            onClick={handleBackToEmail}
          />
        )}
      </OtpNextButtonWrapper>
    </>
  );
};

export default ChangeEmailOTP;
